<template>
  <div class="content">
    <base-block class="mb-0" rounded title="User Test Reports">
      <div class="d-flex justify-content-end mb-2">
        <input
          class="form-control"
          type="text"
          placeholder="Search..."
          aria-label="Search"
          style="width: 300px"
        />
      </div>
      <b-table-simple responsive bordered striped table-class="table-vcenter">
        <b-thead>
          <b-tr>
            <b-th class="text-center" style="width: 50px">S.NO</b-th>
            <b-th class="text-center">Parent Topic</b-th>
            <b-th class="text-center">Correct</b-th>
            <b-th class="text-center">Incorrect</b-th>
            <b-th class="text-center">Unattempted</b-th>
            <b-th class="text-center">Percentage</b-th>
            <b-th class="text-center">Total Score</b-th>
            <!-- <b-th class="text-center">Questions</b-th> -->
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(report, index) in reports" :key="index">
            <b-td class="text-center">{{ index + 1 }}</b-td>
            <b-td class="text-center">{{ report.topic_name }}</b-td>
            <b-td class="text-center">{{ report.total_correct_answer }}</b-td>
            <b-td class="text-center">{{ report.total_incorrect_answer }}</b-td>
            <b-td class="text-center">{{ report.total_unattempted }}</b-td>
            <b-td class="text-center">{{ report.pass_percentage }}</b-td>
            <b-td class="text-center">{{ report.score }}</b-td>
            <!-- <b-td class="text-center">
              <b-button size="sm" variant="alt-primary" v-b-modal.modal-1 @click="getResults(report.id)">
                <i class="fa fa-fw fa-eye"></i>
              </b-button>
            </b-td> -->
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- Questions Modal -->
      <b-modal
        id="modal-1"
        ref="modalone"
        title=" Questions List"
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        hide-footer
      >
       <b-table-simple responsive bordered striped table-class="table-vcenter">
        <b-thead>
          <b-tr>
            <b-th class="text-center" style="width: 50px">S.NO</b-th>
            <b-th class="text-center">Questions</b-th>
                 <b-th class="text-center">Correct Answer</b-th>
            <b-th class="text-center">User Answer</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(result, index) in results" :key="index">
            <b-td class="text-center">{{ index + 1 }}</b-td>
            <b-td class="text-center">{{ result.questions.question }}</b-td>
            <b-td class="text-center">{{ result.questions.answer }}</b-td>
            <b-td class="text-center">{{ result.answer }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
        <div class="text-right">
            <b-button variant="success" @click="$refs.modalone.hide();">Ok</b-button>
        </div>
      </b-modal>
    </base-block>
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() {
    this.getReport();
  },
  methods: {
    async getResults(id) {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-answers/${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.results = response.data.answer_lists;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getReport() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-report/${this.$route.params.testId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.reports = response.data.report_lists;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
  data() {
    return {
      reports: [],
      results: [],
      reportId: ""
    };
  },
};
</script>